<div class="col-xl-12" *ngIf="data">
	<div mat-dialog-content *ngIf="data.data">
		<div>
			<div class="profile-page-header-main" fxLayout="row" fxLayout.lt-md="column">
				<div fxFlex class="row1">
					<div class="name">
						{{data.data['name']}}
					</div>
					<div class="value">
						<span class="inlineText">{{data.data['email0']}}</span>
					</div>

					<div class="value" *ngIf="!isAdmin">
						<span class="inlineText">{{data.data['agency_name']}}</span>
					</div>

					<div class="value">
						<span class="inlineText">{{data.data['newUserType']}}</span>
					</div>
					<div class="value">
						<span class="inlineText">State: {{data.data['business_state']}}</span>
					</div>
					<ng-container *ngIf="!isAdmin">
						<!-- <div class="value">
							<span class="inlineText">Agency: {{data.data['agency_name']}}</span>
						</div> -->
						<div class="value">
							<span class="inlineText">Payee ID: {{data.data.payee_id || '-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Contract Date: {{data.data.text9 || '-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Business Development Manager: {{data.data.people17 ||
								'-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Licensing Specialist: {{data.data.people8 || '-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Personal Lines Consultant: {{data.data.people2 ||
								'-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Commercial Business Consultant: {{data.data.people4 ||
								'-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Accounting Contact: {{data.data.people40 || '-'}}</span>
						</div>

						<div class="value">
							<span class="inlineText">Commissions Contact: {{data.data.people1 || '-'}}</span>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<div fxLayout="row" fxLayoutGap="1vw">
			<div fxFlex>
				<button mat-raised-button color="danger" (click)="closeModal(undefined)">{{'Close' |
					translate}}</button>
			</div>
			<div fxFlex fxLayoutAlign="end center" class="dnd">
				<mat-slide-toggle [(ngModel)]="isDnd" color="primary" [disableRipple]="true"
					(change)="saveDnd()">{{'DND' |
					translate}}</mat-slide-toggle>
			</div>
		</div>
	</div>
</div>